import { ExcludedCampaignType } from '../../context/CloningCampaignsContext.types';
import { ExcludedCampaign } from './ExcludedCampaign';
import {
  EXCLUDED_CAMPAIGN_TABLE_ID,
  EXCLUDED_CAMPAIGN_TABLE_HEADER_ID,
  EXCLUDED_CAMPAIGN_TABLE_COUNT_ID,
} from '../constants';
import {
  Container,
  CampaignsColumnContainer,
  CampaignsTableContainer,
  Column,
  Header,
} from '../styles';

type ExcludedCampaignsTemplatesProps = {
  excludedCampaigns: ExcludedCampaignType[];
};

export const ExcludedCampaignsTemplates = ({
  excludedCampaigns,
}: ExcludedCampaignsTemplatesProps) => {
  const count = excludedCampaigns?.length;

  return (
    <Container data-test={EXCLUDED_CAMPAIGN_TABLE_ID}>
      <Header
        data-test={EXCLUDED_CAMPAIGN_TABLE_COUNT_ID}
      >{`Will not be copied (${count})`}</Header>
      <CampaignsColumnContainer data-test={EXCLUDED_CAMPAIGN_TABLE_HEADER_ID} $isCloneable={false}>
        <Column>ID</Column>
        <Column>Campaign name</Column>
      </CampaignsColumnContainer>
      <CampaignsTableContainer $areOptionsLoaded $isCloneable={false}>
        {count > 0 &&
          excludedCampaigns?.map((c: ExcludedCampaignType) => (
            <ExcludedCampaign key={c?.campaignId} excludedCampaign={c} />
          ))}
      </CampaignsTableContainer>
    </Container>
  );
};
